import React from 'react';
import { Link } from 'react-router-dom';
import './index.scss';
export const CommonFooter = props => {
	return (
		<footer className="common-footer">
			<div className="common-footer-info">
				<Link to="/vpmobile/copyright/about">关于投图</Link>｜<Link to="/vpmobile/copyright/notice">版权声明</Link>｜ <a href="/vpmobile/static/html/partner/photograper.html">合作摄影师</a>｜{' '}
				<a href="/vpmobile/static/html/partner/index.html">合作机构</a> <br /> 客服电话 <a href="tel:4008065775">400-806-5775</a>
			</div>
			<div className="common-footer-copyright">
				© 投图 All Rights Reserved.
				<br />
				唯存（上海）网络科技有限公司沪ICP备15052682号-2
			</div>
		</footer>
	);
};
